<script>
    import { Router, Route, Link } from "svelte-navigator";
    import Login from "./admin/Login.svelte";
    import Home from "./admin/Home.svelte";

    let loggedIn = true;
    // check if logged in
    let lia = window.sessionStorage.cl_lia;

    // if (lia == undefined) {
    //     loggedIn = false;
    // } else {
    //     loggedIn = true;
    // }
</script>

<main>
    <Router primary={false}>
        <Route path="/*">
            {#if loggedIn}
                <Home />
            {:else}
                <Login />
            {/if}
        </Route>
    </Router>
</main>

<style>
    main {
        background: #1d1d1d;
        min-height: 100vh;
    }
</style>
